module.exports = __webpack_public_path__ + "static/media/silver.7aa39b84.svg";